import Link from "next/link";

export function Footer() {
  return (
    <footer className="border-t border-border py-8 px-5 sm:px-8">
      <div className="max-w-5xl mx-auto text-center text-xs text-muted">
        <div className="flex flex-wrap items-center justify-center gap-x-2 sm:gap-x-4">
          <Link href="/powerpoint-to-anki" className="inline-flex min-h-11 items-center justify-center px-1 hover:text-foreground">PowerPoint to Anki</Link>
          <span>·</span>
          <Link href="/pdf-to-anki" className="inline-flex min-h-11 items-center justify-center px-1 hover:text-foreground">PDF to Anki</Link>
          <span>·</span>
          <Link href="/privacy" className="inline-flex min-h-11 min-w-11 items-center justify-center px-1 hover:text-foreground">Privacy</Link>
          <span>·</span>
          <Link href="/terms" className="inline-flex min-h-11 min-w-11 items-center justify-center px-1 hover:text-foreground">Terms</Link>
          <span>·</span>
          <Link href="/contact" className="inline-flex min-h-11 min-w-11 items-center justify-center px-1 hover:text-foreground">Contact</Link>
          <span className="hidden sm:inline">·</span>
          <span className="w-full sm:w-auto">&copy; 2026 SlideToAnki</span>
        </div>
      </div>
    </footer>
  );
}
